import profile from "../assets/images/profile.jpg";
import flipkart from "../assets/flipkart.jpg"
import chatapp from "../assets/chatappimg.webp"
import gmail from "../assets/g-mailclone.jpg"
import webscrap from "../assets/webscraping.jpg"
import noteimg from "../assets/noteimg.webp"
export const portfolioData = {
    personal: {
        name: "Chitrarasu A",

        role: "Full Stack Developer",

        tagline:
            "Passionate Full Stack Developer specializing in React, Angular, Node.js, MongoDB, and AWS. I enjoy building scalable, high-performance web applications with clean architecture and modern user experiences.",

        email: "chitrarasumit@gmail.com",

        phone: "+91 8838929800",

        github: "https://github.com/chitrarasu1996",

        linkedin:
            "https://www.linkedin.com/in/chitrarasu-a-mern-stack-developer/",

        resume: "/resume.pdf",

        profileImage: profile,
    },
    about: {
    subtitle: "ABOUT ME",
    title: "Building digital solutions with passion and purpose.",
    description: "I'm a Full Stack Developer with 2+ years of experience in building end-to-end web applications. I specialize in React, Angular, Node.js, and cloud technologies. I love turning complex problems into simple, beautiful, and intuitive solutions.",
    stats: [
      { id: 1, value: "2+", label: "Years Experience" },
      { id: 2, value: "5+", label: "Projects Completed" },
      { id: 3, value: "10+", label: "Technologies" },
      { id: 4, value: "2", label: "Certifications" }
    ]
  },
  skills: [
    { name: "HTML5", iconClass: "html5" },
    { name: "CSS3", iconClass: "css3" },
    { name: "JavaScript", iconClass: "javascript" },
    { name: "Bootstrap", iconClass: "bootstrap" },
    { name: "React", iconClass: "react" },
    { name: "Angular", iconClass: "angular" },
    { name: "Node.js", iconClass: "node" },
    { name: "Express", iconClass: "express" },
    { name: "GitHub", iconClass: "github" },
    { name: "SQL", iconClass: "sql" },
    { name: "MongoDB", iconClass: "mongodb" },
    { name: "TypeScript", iconClass: "typescript" }
  ],
  experience: [
   {
      id: 1,
      role: "Freelance Full Stack Developer",
      company: "Independent / Freelance",
      location: "Remote",
      duration: "Nov 2025 - Present",
      description: "Architecting and delivering specialized web applications for clients. Managing end-to-end delivery pipelines including database normalization, secure JWT-based backend REST architectures, and reactive frontend designs across multiple tech stacks."
    },
    {
      id: 2,
      role: "Full Stack Developer",
      company: "Impelox Tech Private Limited",
      location: "Chennai, India",
      duration: "2024 - Nov 2025",
      description: "Developed and optimized high-performance web applications using the MERN stack, Angular. Collaborated on structural API integrations, engineered interactive client-side interfaces, and managed transactional relational database models."
    }
    // You can easily paste additional history objects here in the future
  ],
  // 1. Standalone Flagship Project Module
  featuredProject: {
    title: "E-commerce Application",
    subtitle: "FEATURED PROJECT",
    description: "A comprehensive, high-performance E-Commerce Platform built utilizing the MERN Stack. Features secure transactional handling, responsive dynamic routing, product catalog structures, and a streamlined interface layout.",
    image: flipkart,
    tags: ["MongoDB", "Express.js", "React", "Node.js", "Netlify"],
    liveLink: "https://ecommerce-shop-123.netlify.app/",
    githubLink: "https://github.com/chitrarasu1996/e-commerce.git"
  },

  // 2. Regular Grid Project Showcase list
projects: [
    {
      id: 1,
      title: "E-commerce Application",
      description: "A high-performance E-Commerce platform built using the MERN stack. Features dynamic product catalogs, a comprehensive checkout simulation layout, and structural API endpoint integrations.",
      stack: "MongoDB, Express.js, React, Node.js, Netlify",
      image: flipkart,
      liveLink: "https://ecommerce-shop-123.netlify.app/",
      githubLink: "https://github.com/chitrarasu1996/e-commerce.git"
    },
    {
      id: 2,
      title: "Realtime Chatapp",
      description: "A fast real-time communication portal incorporating WebSockets for instant message event dispatches between connected client sockets.",
      stack: "Socket.io, React, Node.js, Express, MongoDB",
      image: chatapp,
      liveLink: "https://chattify-app.netlify.app",
      githubLink: "https://github.com/chitrarasu1996/chat-app-frontend.git"
    },
    {
      id: 3,
      title: "Gmail-clone",
      description: "An email web client layout simulation managing backend structural queries and handling secure automated transactional messaging.",
      stack: "Node.js, Nodemailer, React, Express, MongoDB",
      image: gmail,
      liveLink: "https://gmail-colone.netlify.app",
      githubLink: "https://github.com/chitrarasu1996/gmail-clone-frontend.git"
    },
    {
      id: 4,
      title: "Note-taking App",
      description: "An interactive, clean note organizer application built with the full MERN stack, managing continuous CRUD modifications.",
      stack: "React, Node.js, Express, MongoDB, Tailwind CSS",
      image: noteimg,
      liveLink: "https://notes-taking-application-frontend.netlify.app/",
      githubLink: "https://github.com/chitrarasu1996/notes-taking-application-frontend.git"
    },
    {
      id: 5,
      title: "Web-scraping Engine",
      description: "An automated data extractor engineered to map custom layout structures and bundle target parameters seamlessly into API endpoints.",
      stack: "Cheerio, Axios, Node.js, Express, React",
      image: webscrap,
      liveLink: "https://web-scraping-123.netlify.app/",
      githubLink: "https://github.com/chitrarasu1996/frontend-webscraping.git"
    },
    
  ],
certificationsData : [
    {
      id: 1,
      title: "Full Stack Development Certification",
      issuer: "Guvi", // You can change the issuer name if it's different
      date: "2023",
      description: "Comprehensive specialization covering end-to-end web architecture, database design, REST API engineering, and modern frontend frameworks.",
      credentialUrl: "https://www.guvi.in/share-certificate/955Mg783E91I1Q1766", // Add your certificate view link here if you have one
    },
    {
      id: 2,
      title: "Advanced JavaScript & ES6 Specification",
      issuer: "Guvi", // You can change the issuer name if it's different
      date: "2023",
      description: "Deep dive into asynchronous programming, closures, prototypes, event loop mechanics, and scalable modern JavaScript application patterns.",
      credentialUrl: "https://www.guvi.in/verify-certificate?id=0A956U21QP5F9071hu", // Add your certificate view link here if you have one
    },
    {
      id: 3,
      title: "React.js Developer Certification",
      issuer: "Guvi",
      date: "2024",
      description: "Advanced frontend development focusing on component lifecycles, hooks, context state routing, and structural virtual DOM architectures.",
     credentialUrl: "https://www.guvi.in/verify-certificate?id=752ePa1Q9A180T8Yd3", // Add your certificate view link here if you have one

    },
    {
      id: 4,
      title: "Node.js Server Application Engineering",
      issuer: "Guvi",
      date: "2024",
      description: "Backend architecture specializing in asynchronous event loops, modular microservices, REST API engineering, and secure token middleware validations.",
      credentialUrl: "https://www.guvi.in/verify-certificate?id=8c15132os804FrWM79",    
    },
    {
      id: 5,
      title: "MongoDB NoSQL Data Architecture",
      issuer: "Guvi",
      date: "2024",
      description: "Document-oriented database management, modeling nested schema configurations, complex pipeline aggregations, and query indexing optimizations.",
      credentialUrl: "https://www.guvi.in/verify-certificate?id=2g8741f35H38W918V0"
    },
    {
      id: 6,
      title: "MySQL Relational Database Specialization",
      issuer: "Guvi",
      date: "2024",
      description: "Relational schema management handling strict transactional query scripts, complex multi-table joins, indexing configurations, and structural ACID parameters.",
      credentialUrl: "https://www.guvi.in/verify-certificate?id=7EK5r03121R89w2yN8"
    },
    {
      id: 7 ,
      title: "HTML5 & Semantic Web Specification",
      issuer: "Guvi",
      date: "2024",
      description: "Structuring high-performance layouts using modern semantic element tags, search engine visibility architectures, and document object tree models.",
      credentialUrl: "https://www.guvi.in/verify-certificate?id=d9u181N38X5728UG0t"
    },
    {
      id: 8,
      title: "CSS3 Fluid Layout Architecture",
      issuer: "Guvi",
      date: "2024",
      description: "Advanced stylistic web layouts utilizing Flexbox flow structures, Grid systems, responsive media queries, and high-performance cubic animation frameworks.",
      credentialUrl: "https://www.guvi.in/share-certificate/kp51i2808f710d39n7"
    },
    {
      id: 9,
      title: "Bootstrap UI Responsive Blueprinting",
      issuer: "Guvi",
      date: "2024",
      description: "Rapid mobile-first rapid interface development leveraging grid systems, utility classes, dynamic UI components, and theme customizations.",
      credentialUrl: "https://www.guvi.in/verify-certificate?id=h1sg5O02l8938G71xc"
    }
  ]
};